module.exports = __webpack_public_path__ + "img/logo1.274de929.svg";